// @flow

import { Component, type Node } from 'react';

import { childOrWrapChildren } from 'app/common/utils/ReactUtils';

type Props = {
  onMount: (props: Props) => any,
  onUnmount: (props: Props) => any,
  children?: Node,
};

class MountUnmount extends Component<Props> {
  static defaultProps = {
    onMount: () => {},
    onUnmount: () => {},
  };

  componentDidMount() {
    this.props.onMount(this.props);
  }

  componentWillUnmount() {
    this.props.onUnmount(this.props);
  }

  render() {
    return childOrWrapChildren(this.props.children);
  }
}

export default MountUnmount;
